module.exports = __webpack_public_path__ + "img/Tirosnab_Gray_1280x1010.e5e8a621.jpg";